import Translate from "./Translate.jsx";
import React from "react";

export default function CaricamentoInCorso() {

    return (
        <p><Translate>Caricamento in corso...</Translate></p>
    );
}
